// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-2bac0e45&scoped=true!./~/less-loader?sourceMap!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/clients/SelectClientModal.vue
// module id = 432
// module chunks = 0